import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Kartable_Customer_Device_Interface } from 'src/app/Interface/Kartable_Customer_Device_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-KartableCustomerReport',
  templateUrl: './KartableCustomerReport.component.html',
  styleUrls: ['./KartableCustomerReport.component.scss']
})
export class KartableCustomerReportComponent implements OnInit {

  Token: String = ""
  Customer_Filter_List: string = ""
  page: number = 0;
  Procssing: boolean = false
  BaseUrl = environment.BaseUrl

  modalRef_Delete: any;
  DataList_Certificate: Array<Kartable_Customer_Device_Interface> = []
  constructor(
    private Kartable_Service: KartableService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }



  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2216).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  ReadData_Certificate(StartSearchDate, EndSearchDate) {
    this.Procssing = true
    this.Kartable_Service.GetCustomerDeviceReview(this.Token, StartSearchDate, EndSearchDate, this.Customer_Filter_List).subscribe(
      data => {
        this.DataList_Certificate = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }






  //#region Letter Modal

  LetterModalList: Array<any> = []
  LetterModalList_letter: Array<any> = []
  modalRef_Letter: any
  pageLetter = 0
  openModalRef_Letter(template: TemplateRef<any>, Record) {
    this.LetterModalList = Record
    this.LetterModalList_letter = []
    this.modalRef_Letter = this.modalService.show(template);
  }

  exportexcel_Letter(Record): void {
    this.LetterModalList_letter = Record
  }

  //#endregion

  //#region Calibration

  CalibrationModalList: Array<any> = []
  modalRef_Calibration: any
  openModalRef_Calibration(template: TemplateRef<any>, Record) {
    this.CalibrationModalList = Record
    this.modalRef_Calibration = this.modalService.show(template);
  }


  //#endregion

}
